//core
import React from 'react';
import { makeStyles } from '@material-ui/core';
//material-ui
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
//dashboard-pro
import Button from "components/CustomButtons/Button.jsx";
//css
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const confirmModalStyle = makeStyles(theme => (modalStyle));

function ConfirmModal(props){
    const classes = confirmModalStyle();
    return (
        <Dialog classes={{root:classes.center,paper:classes.modal}} 
            open={props.open} 
            transition={Transition}
            maxWidth='md'
            fullWidth={true}
            keepMounted
            onClose={props.close}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">
            <DialogTitle id="classic-modal-slide-title"
                disableTypography
                className={classes.modalHeader}>
                <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    color="transparent"
                    onClick={props.close}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>确认</h4>
            </DialogTitle>
            <DialogContent id="FAQ-modal-slide-description" className={classes.modalBody}>
                确认提交资质证书？带星*标记项为必传！未上传将影响审核结果，请确认！
            </DialogContent>
            <DialogActions className={classes.modalFooter +" " +classes.modalFooterCenter}>
                <div>
                <Button onClick={props.close}>取消</Button>
                <Button onClick={props.confirm} color="success">确定</Button>
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmModal;

